import { useSelector } from 'react-redux';
import translation from '../../../languages';
import cn from '../../../utils/classnames';
import isSaleAllowed from '../../../utils/material/is-sale-allowed';
import { isFreeMaterial } from '../../../utils/material/material-helper';
import CurrencyPrice from '../../currency-price/currency-price';

type PriceBlockProps = TranslationProps & { item: Material; className?: string };

const PriceBlock = (props: PriceBlockProps) => {
    const { item, className, t } = props;
    const { price, sale } = item;

    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);

    const isItemOnSale = Boolean(sale?.original_price) && isSaleAllowed(item, countryCode);

    return (
        <span className={cn('price-block', className, { 'price-highlighted': isItemOnSale })}>
            {isFreeMaterial(item) ? t('common.materialBlock.free') : <CurrencyPrice price={price} />}
        </span>
    );
};

const translate = translation('common');

export default translate(PriceBlock);
